// Used to display different company name in different hosts
import Vue from 'vue';
import axios from 'axios';
import { getCompanyName } from '@/utils/whitelabel-utils';

window.setCompanyName = (companyName) => {
  window.companyName = companyName;
  Vue.prototype.$companyName = window.companyName;
  document.documentElement.style.setProperty('--company-logo', `var(--${window.companyName}-logo)`);
  // axios.defaults.headers.common['X-Product'] = companyName.toLowerCase();
};

window.whiteLabelCompany = getCompanyName(window.location.hostname);
window.setCompanyName('Renova');

// Additional temporary property to set what layout to use for Admin Section
window.adminLayout = 'RenovaDashboardLayout';
